import EventsMixin from "app/mixins/events";

class View {

    constructor() {
        Object.assign(this, EventsMixin);
    }

    init() {
    }

    mount(appCtx) {
    }

    unmount(appCtx) {
    }

}

export default View;
